import * as z from "zod";

export const getBooleanFeatureFlag = {
  name: "getBooleanFeatureFlag" as const,
  input: z.object({ key: z.string() }),
  output: z.object({ enabled: z.boolean() }),
};
